import type { GroupMember } from '../../../../types'

export type MemberPickerProps = {
    members: GroupMember[]
    selected: string[]
    onChange: (memberIds: string[]) => void
    disabled?: boolean
    label: string
}

/**
 * Výběr osob, kterým položka patří. Řešeno jako řada přepínacích tlačítek -
 * na mobilu se tak dá položka rozdělit jedním klepnutím na osobu.
 */
export function MemberPicker({ members, selected, onChange, disabled, label }: MemberPickerProps) {
    const toggle = (memberId: string) => {
        onChange(selected.includes(memberId) ? selected.filter((id) => id !== memberId) : [...selected, memberId])
    }

    return (
        <div className="d-flex flex-wrap gap-1" role="group" aria-label={label}>
            {members.map((member) => {
                const active = selected.includes(member.id)
                return (
                    <button
                        key={member.id}
                        type="button"
                        disabled={disabled}
                        aria-pressed={active}
                        className={`btn btn-sm ${active ? 'btn-primary' : 'btn-outline-secondary'}`}
                        style={active ? { backgroundColor: member.color, borderColor: member.color } : undefined}
                        onClick={() => toggle(member.id)}
                    >
                        {member.displayName}
                    </button>
                )
            })}
        </div>
    )
}
